/**
 * A floating action pinned to the bottom right (the station's forecast-model
 * chip) carries this attribute: the shell (AppContainer) then lifts the
 * alert snackbar above it.
 */
export const FLOATING_ACTION_ATTR = 'data-floating-action';
